
import {StrategyBaseClass} from './strategy-base-class.js'


export class WebchatService extends StrategyBaseClass {
  constructor($translate) {
    super($translate);
  }

  getType() {
    return 10; // alcmeon.db.Sites.TYPE_WEBCHAT
  }
  getTypeString() {
    return 'webchat';
  }
  getAllTasksTypes() {
    return [32];
  }
  getTaskTypeString(taskType) {
    let mapping = {
      32 : 'webchat/msg'
    };
    return mapping[taskType];
  }
  
  getTaskTypeQueueId(taskType) {
    let mapping = {
      32 : 'webchat-msg'
    };
    return mapping[taskType];
  }
  
  getPrivateTaskTypes() {
    return [32];
  }

  canHaveSurveys() {
    return true;
  }

  getEditorConfiguration(isPrivate) {
    return {
      'pictureEnabled': true,
      'imageMimeTypes': 'image/*',
    };
  }

  getQuickRepliesElementsConfig() {
    return {
      maxAnswerNb: 11,
      answerLabelMaxLength: 50,
      hasDescription: false,
      canHaveUserVariableInRootQuestion: true,
      hasPhoneEmailAnswerType: false,
      hasUrlAnswerType: false,
      hasTargetAppId: false,
      boxesCanBeTested: false,
      hasPersistentMenu: true,
      hasWelcomeMessage: false,
      imageMimeTypes: 'image/*',
      editorConfiguration: {
        fileEnabled: true,
        hasImageControl: false
      },
      hasAddUrlButtonButton: true,
      sendTextAfterButtonChoice: false,
      canSendVideo: true
    };
  }

  static WebchatFactory($translate) {
    return new WebchatService($translate);
  }
}
WebchatService.WebchatFactory.$inject = ['$translate'];
